define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/_base/underscore",
	"csi/html",
	"csi/widget/CheckedMultiSelectDropdown",
	"./_SelectSwitchboard"
], function(declare, lang, when, _, html, CheckedMultiSelectDropdown, _SelectSwitchboard) {

	return declare(_SelectSwitchboard, {
		selectClass: CheckedMultiSelectDropdown,

		/** @property {boolean} bAutoSelectIfOne - if only one result in store, then select */
		//bAutoSelectIfOne: false,

		/** @property {boolean} bForceQuery - set to true to force query so results (and count) are known on startup */
		//bForceQuery: false,

		onSelectParams: function(/*Object*/params) {
			// summary: add options for select widget
			params.defaultClearText = this.defAction.bMultipleNone ? "SelectNone" : "SelectAll";
		},

		shouldForceQuery: function() {
			//summary: return true if query results need to be known on startup rather than delayed until user interaction
			return this.bForceQuery || this.defAction.bMultipleAll;
		},

		_onChangeSelect: function(/*String[]*/value) {
			// summary: notify listeners of change
			// FIX: when multi-select widget with defaultAll set to true changes to return value with all store contents,
			// then we can simplify this code and not have to deal with "externalValue"
			this.inherited(arguments, [this.selectNode.get("externalValue")]);
		},

		_onDefaultValue: function(/*String[]?*/preferredValue, /*Object[]*/results) {
			// summary: if value is given and still exists in store, then use it; otherwise set to default value
			if (!html.exists(this)) {
				this._resolveDeferred();
				return;
			}

			const {bAutoSelectIfOne, selectNode, store} = this;
			const {length} = results;
			let value;

			if (!length) {
				// nothing in store if no default value
				selectNode.set("disabled", true);
				this._bEmptyStore = true;
				value = [];
			} else {
				value = _.filter(preferredValue, (id) => !!store.getFromMemory(id));

				if (bAutoSelectIfOne && !value.length && (length === 1)) {
					value = [store.getIdentity(results[0])];
				}
			}

			const valueOld = selectNode.get("value") || [];

			if (_.isEqual(value, valueOld)) {
				// call onChange even if values are same so view is notified
				this._setSwitchboardValue(value);
			} else {
				this._setSelectNodeValue(value);
			}

			this._resolveDeferred();
		},

		_setSelectNodeValue: function(/*String?*/value) {
			// summary: override natural way of setting widget value with custom function for multi-select widget (ugh!)
			this.selectNode.resetSelected(value);
		},

		_setValueAttr: function(/*String[]?*/value) {
			// summary: query store if available before setting value if not empty or if default value is to select all
			if (this.store && (this.shouldForceQuery() || !_.isEmpty(value))) {
				when(this.store.query(), lang.hitch(this, this._onDefaultValue, value));
			} else {
				this.inherited(arguments, [value || []]);
				this._resolveDeferred();
			}
		}
	});
});